module.exports = __webpack_public_path__ + "static/media/9c30c625-fb84-407a-81d0-31d74e415909.51c580cc.JPG";